import { Snackbar, snackbarContentClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledSnackbar = styled(Snackbar)(({ theme }) => ({
    bottom: '40px',

    [`& .${snackbarContentClasses.root}`]: {
        [theme.breakpoints.up(600)]: {
            minWidth: 'calc(344px - 32px)',
        },
    },

    [`& .${snackbarContentClasses.message}`]: {
        fontSize: '14px',
        lineHeight: '24px',
        color: '#E3E3E3',
        fontWeight: 'normal',
        padding: '6px 0 6px 16px',
    },

    '& > * + *': {
        marginTop: theme.spacing(2),
    },
}));
